import { CalAndNewsFileInfo, MyFile } from "./fileInfo";


export class Rubric {

	id = "";
	name = "";
	active = true;
	userSubscribable = true;

}

export class RubricBackend {

	rubrikId = "";
	rubrikName = "";
	active = true;
	special = false;

}



export class News {

	id = "";
	title = "";

	rubrics: string[] = [];
	categories: string[] = [];

	contactTitle = "";
	contactFirstName = "";
	contactFamilyName = "";
	contactPhone = "";
	contactEmail = "";


	url = "";
	content = "";

	bReleased = false;

	myFiles: MyFile[] = [];

	creationTms: number | null = ( new Date() ).getTime();

	bSeen = false;

}


export class NewsBackend {

	erstellungsDatum: null | number = 0;
	freigabe = false;

	kategorieIds: string[] = [];
	rubrikIds: string[] = [];

	kontaktAnrede = "";
	kontaktEmail = "";
	kontaktName = "";
	kontaktTelephonNr = "";
	kontaktVorname = "";

	nachrichtenId = "";
	nachrichtenInhalt = "";
	titel = "";
	url = "";

	dateien?: CalAndNewsFileInfo[] = [];

}


export class NewsCategory {
	bezeichnung = "";
	kategorieId = "";
}
